import { Pipe, PipeTransform } from '@angular/core';
import { LoggedInUser, UserRoles } from '../../users/users.models';
import { checkPermissions } from '../../users';

@Pipe({
    name: 'liebherrPermission',
})
export class CheckPermissionPipe implements PipeTransform {
    constructor() {}

    transform(user: LoggedInUser, roles: UserRoles[]): boolean {
        return user ? checkPermissions(user, roles) : false;
    }
}
